@use "variables" as *;

.imageFloatLeft {
  float: left;
  margin-right: $spacing-m;
}
